import axios from "axios";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

export const baseURL =
  import.meta.env.VITE_BACKEND_URL || window.location.origin;

const api = axios.create({
  baseURL,
});

api.interceptors.request.use((config) => {
  if (import.meta.env.VITE_AUTH_SKIP.toLowerCase() === "true") {
    return config;
  }
  const jwt = cookies.get(import.meta.env.VITE_AUTH_TOKEN_ID);
  if ((jwt !== null || jwt !== undefined) && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
});

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 401 || (status === 403 && detail !== "module_disabled")) {
      window.location.href = import.meta.env.VITE_LOGIN_REDIRECT_URL;
    } else {
      return Promise.reject(error);
    }
  },
);

export default api;
